import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUsuarioLogado } from '../utils/auth';
import './Planos.css';

// Dados dos planos de assinatura
const PLANOS_ASSINATURA = [
  {
    id: 'basic',
    nome: 'Basic',
    preco: 'R$ 49,90/mês',
    cor: 'rgb(235, 133, 0)',
    recursos: [
      'Acesso a até 3 usuários',
      'Relatórios básicos',
      'Suporte por email',
      'Armazenamento de 5GB',
      'Integrações básicas'
    ]
  },
  {
    id: 'pro',
    nome: 'Pro',
    preco: 'R$ 99,90/mês',
    cor: 'rgb(235, 133, 0)',
    destaque: true,
    recursos: [
      'Acesso a até 10 usuários',
      'Relatórios avançados',
      'Suporte prioritário 24/7',
      'Armazenamento de 25GB',
      'Todas as integrações'
    ]
  },
  {
    id: 'premium',
    nome: 'Premium',
    preco: 'R$ 199,90/mês',
    cor: 'rgb(235, 133, 0)',
    recursos: [
      'Usuários ilimitados',
      'Relatórios personalizados',
      'Gerente de conta dedicado',
      'Armazenamento ilimitado',
      'API completa + Integrações'
    ]
  }
];

export default function Planos() {
  const navigate = useNavigate();
  const usuarioLogado = getUsuarioLogado();
  const [planoAtual, setPlanoAtual] = useState(null); // null = sem plano

  const handleContinuar = (plano) => {
    // TODO: Integrar com Stripe
    console.log('Plano selecionado:', plano.id);
    alert(`Plano "${plano.nome}" selecionado! Integração com Stripe em breve.`);
  };

  return (
    <div className="planos-page-container">
      <div className="planos-page-card">
        {/* Header */}
        <div className="planos-page-header">
          <button className="planos-btn-voltar" onClick={() => navigate('/sidebar/Configuracoes')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Voltar
          </button>
          <div className="planos-header-content">
            <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="2" y="6" width="20" height="14" rx="2" stroke="rgb(235, 133, 0)" strokeWidth="1.5" fill="none"/>
              <path d="M2 8l10 6 10-6" stroke="rgb(235, 133, 0)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M15 2l4 4-8 8H7v-4l8-8z" fill="#fff" stroke="rgb(235, 133, 0)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M13 4l4 4" stroke="rgb(235, 133, 0)" strokeWidth="1.5"/>
            </svg>
            <h2>Meus Planos</h2>
            <p>Escolha o plano ideal para o seu negócio</p>
          </div>
        </div>

        {/* Status do Plano Atual */}
        <div className="planos-status-atual">
          {planoAtual ? (
            <div className="plano-ativo-info">
              <span className="plano-badge-ativo">Plano Ativo</span>
              <span className="plano-nome-ativo">{planoAtual}</span>
            </div>
          ) : (
            <div className="sem-plano-info">
              <span className="sem-plano-icone">📋</span>
              <p>Você não possui planos.</p>
              <p className="sem-plano-subtexto">Veja os planos disponíveis abaixo:</p>
            </div>
          )}
        </div>

        {/* Cards dos Planos */}
        <div className="planos-grid">
          {PLANOS_ASSINATURA.map((plano) => (
            <div 
              key={plano.id} 
              className={`plano-card ${plano.destaque ? 'plano-card-destaque' : ''}`}
            >
              {plano.destaque && <div className="plano-tag-popular">Mais Popular</div>}
              
              <div className="plano-card-header">
                <h4 className="plano-card-titulo">{plano.nome}</h4>
                <p className="plano-card-preco">{plano.preco}</p>
              </div>
              
              <ul className="plano-card-recursos">
                {plano.recursos.map((recurso, idx) => (
                  <li key={idx}>
                    <span className="recurso-check-icon">✓</span>
                    {recurso}
                  </li>
                ))}
              </ul>
              
              <button 
                className="plano-card-btn"
                onClick={() => handleContinuar(plano)}
              >
                Continuar
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
